import * as React from "react";

export const mapMouseEventAsPosition = ({
    currentTarget: {
        clientWidth,
        offsetLeft,
        offsetParent,
        offsetTop,
    }}:React.MouseEvent<HTMLElement>
) => (
    {
        right   : (offsetParent?.clientWidth ?? 0) - offsetLeft - clientWidth,
        top     : offsetTop,
    }
);

